/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Unknown_Server_ErrorInputs */

const en_toast_unknown_server_error = /** @type {(inputs: Toast_Unknown_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown server error`)
};

const nl_toast_unknown_server_error = /** @type {(inputs: Toast_Unknown_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbekende serverfout`)
};

/**
* | output |
* | --- |
* | "Unknown server error" |
*
* @param {Toast_Unknown_Server_ErrorInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_unknown_server_error = /** @type {((inputs?: Toast_Unknown_Server_ErrorInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Unknown_Server_ErrorInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_unknown_server_error(inputs)
	return en_toast_unknown_server_error(inputs)
});